export const config = {
  title: "Home Maintenance & Repair Services | Boyd & Greenup Counties, KY",
  meta: {
    description:
      "Home Maintenance & Repair Services provides reliable home repair and maintenance solutions in Boyd and Greenup Counties, Kentucky. Professional handyman services, home repairs, and property maintenance.",
    keywords: [
      "Home Maintenance Repair Services",
      "Handyman Boyd County KY",
      "Home Repair Greenup County",
      "Property Maintenance Kentucky",
      "Handyman Services KY",
      "Home Improvement Boyd County",
      "Repair Services Kentucky",
      "Maintenance Contractor"
    ],
    author: "Home Maintenance & Repair Services",
    canonicalUrl: "https://www.hmrservices.net/",
  },
  sections: {
    header: {
      businessName: "Home Maintenance & Repair Services",
    },
    sectionB: {
      heroTitle: "Reliable Home Maintenance & Repair Solutions",
      heroSubtitle: "Professional Handyman Services in Boyd & Greenup Counties, KY",
      learnAboutText: "Get Your Free Estimate",
      phoneNumber: "6065478887",
      phoneLabel: "(606) 547-8887",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2187421629/photo/plumber-house-and-handyman-with-clipboard-inspection-and-maintenance-with-expert-employee.jpg?s=612x612&w=0&k=20&c=rqPHAz0849mFaQ2Box2eszZDaZZ9pDbvCUKJCZ700RI=",
      cardData: [
        {
          title: "Home Repairs",
          description:
            "Professional home repair services including drywall, plumbing fixes, electrical work, and general maintenance solutions.",
        },
        {
          title: "Property Maintenance",
          description:
            "Comprehensive property maintenance services to keep your home in excellent condition year-round.",
        },
        {
          title: "Handyman Services",
          description:
            "Expert handyman services for all your home improvement and repair needs, from small fixes to larger projects.",
        },
      ],
      description:
        "Home Maintenance & Repair Services is your trusted partner for reliable home repairs and maintenance solutions throughout Boyd and Greenup Counties, Kentucky.",
    },
    sectionC: {
      servicesTitle: "Comprehensive Home Services",
      servicesDescription:
        "Professional home maintenance and repair services designed to keep your property in excellent condition with reliable, quality workmanship.",
      cards: [
        {
          title: "Home Repair Services",
          description:
            "Expert repair services including drywall repair, door fixes, minor plumbing, electrical work, and general home maintenance solutions.",
          imageSrc: "https://images.unsplash.com/photo-1621905251918-48416bd8575a?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.0.3",
          imageAlt: "Home Repair Services",
        },
        {
          title: "Property Maintenance",
          description:
            "Regular maintenance services including gutter cleaning, power washing, seasonal upkeep, and preventive maintenance programs.",
          imageSrc: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3",
          imageAlt: "Property Maintenance Services",
        },
        {
          title: "Handyman Solutions",
          description:
            "Professional handyman services for home improvements, installations, repairs, and custom solutions tailored to your needs.",
          imageSrc: "https://images.unsplash.com/photo-1562259949-e8e7689d7828?q=80&w=2074&auto=format&fit=crop&ixlib=rb-4.0.3",
          imageAlt: "Handyman Solutions",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Drywall Repair & Patching",
        "Door & Lock Repair",
        "Gutter Cleaning & Maintenance",
        "Power Washing Services",
        "Home Improvement Projects",
      ],
    },
    sectionD: {
      aboutTitle: "About Home Maintenance & Repair Services",
      aboutImage: {
        src: "https://media.istockphoto.com/id/1840366193/photo/close-up-of-repairman-in-uniform-standing-on-home-kitchen-and-holding-his-tool-bag.jpg?s=612x612&w=0&k=20&c=eJ3N5_4DeXrHF7aUaLXVThYsus86KqyMcubsq4Nclco=",
        alt: "Home Maintenance & Repair Services Team",
      },
      aboutText: [
        "Home Maintenance & Repair Services is a trusted provider of comprehensive home repair and maintenance solutions serving Boyd and Greenup Counties, Kentucky. We understand that maintaining a home can be challenging, and we're here to help with reliable, professional service.",
        "Our experienced team is dedicated to providing quality workmanship and excellent customer service for all your home maintenance needs. From minor repairs to larger improvement projects, we handle each job with attention to detail and a commitment to getting it done right the first time.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Home Maintenance & Repair Services",
      businessName: "Home Maintenance & Repair Services",
      contact: {
        phone: "6065478887",
        phoneLabel: "(606) 547-8887",
        email: "iroberts197410@icloud.com",
        website: "https://www.hmrservices.net/",
        address: "Boyd & Greenup Counties, KY",
      },
      socialMedia: {
      },
    },
    sectionF: {
      address: "Boyd & Greenup Counties, KY",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d101058.123456789!2d-82.8756778!3d38.4728567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x884107f1234567890a%3A0x1234567890abcdef!2sBoyd%20County%2C%20KY!5e0!3m2!1sen!2sus!4v1698765432100!5m2!1sen!2sus",
    },
  },
};

export default config;